import { geometrySizeId, SIZE_LADDER } from './transform-edit.js';

const MEDIUM = SIZE_LADDER[2]!.id;
const tier = (id: string | null | undefined): number => SIZE_LADDER.findIndex(entry => entry.id === id?.trim().toUpperCase());

/** Creature rules width, never its mesh/token width. Missing/unknown size is Medium. */
export function inventorySizeIdForBaseFt(baseFt: number | null | undefined): string {
  return SIZE_LADDER.find(entry => entry.baseSize === baseFt)?.id ?? MEDIUM;
}

/**
 * The installed prop's tier: measured, scaled mesh extents (same as occupancy), otherwise inventory/item size.
 * Unmeasurable AND unsized props are Medium, never inventoryBaseSizeFt's legacy Tiny fallback.
 * Callers retain dedicated tree-trunk/structural occupancy policies; yaw does not enlarge the local size band.
 */
export function inventoryStepOverSizeId(sizeId: string | null | undefined, scaledBoundsFt?: readonly number[] | null): string {
  if (scaledBoundsFt) {
    const measured = geometrySizeId(scaledBoundsFt.map(axis => axis * 0.3048), 1);
    if (measured) return measured;
  }
  return tier(sizeId) >= 0 ? sizeId!.trim().toUpperCase() : MEDIUM;
}

/** Owner 2026-10-17: at least TWO tiers smaller is free step-over, including a stop on that space. Corpses are separate. */
export function inventoryStepOver(moverSizeId: string | null | undefined, propSizeId: string | null | undefined): boolean {
  const mover = tier(moverSizeId), prop = tier(propSizeId);
  return (mover < 0 ? 2 : mover) - (prop < 0 ? 2 : prop) >= 2;
}
